<!--
 * @Author: Your Name
 * @Date: 2023-2-28
 * @Description: 订单管理-安心充订单-订单详情
-->
<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <template v-for="(button, index) in pageButtons">
          <ykc-button
            :key="index"
            v-if="button.enabled"
            v-bind="button"
            @click="button.handleClick(button, $event)">
            {{ button.text }}
          </ykc-button>
        </template>
      </div>
    </template>
    <div class="real-time-detail">
      <!-- 用户支付信息/订单 start -->
      <div class="flexConent">
        <ykc-detail
          :isLine="true"
          :tips="tips"
          :titles="[`订单号：${dealData(detailData.tradeSeq)}`]"
          :className="'left'">
          <div slot="cvBody">
            <div class="form-detail flex">
              <ykc-form :label-position="'left'" label-width="130px" class="list-left">
                <ykc-detail-item :label="'订单状态：'">
                  <span>{{ dealData(detailData.tradeStatusName) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'站品牌：'">
                  <span>{{ dealData(detailData.brandName) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'充电用户：'">
                  <span>{{ dealData(detailData.userAccount) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'充电站名称:'">
                  <span>{{ dealData(detailData.stationName) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'终端名称：'">
                  <span>{{ dealData(detailData.gunCode) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'终端ID：'">
                  <span>{{ dealData(detailData.gunId) }}</span>
                </ykc-detail-item>
                <ykc-detail-item :label="'订单结束原因：'">
                  <span>{{ dealData(detailData.stopChargeReasonName) }}</span>
                </ykc-detail-item>
              </ykc-form>
            </div>
          </div>
        </ykc-detail>
        <ykc-detail
          :isLine="true"
          :tips="tips"
          :titles="['用户支付信息']"
          class="table-body left"
          ref="headRight">
          <div slot="cvBody" class="bottom-content">
            <ykc-form :label-position="'left'" label-width="130px" class="list-left">
              <ykc-detail-item :label="'充电电量：'">
                <span>{{ dealData(detailData.chargedPowerOri) }} 度</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'电费：'">
                <span>{{ dealData(detailData.chargedAmount) }} 元</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'服务费：'">
                <span>{{ dealData(detailData.serviceAmount) }} 元</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'订单总金额:'">
                <span>{{ dealData(detailData.totalAmount) }} 元</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'用户实付：'">
                <span>{{ dealData(detailData.totalAmount) }} 元</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'微信商户：'">
                <span>{{ dealData(detailData.mchName) }}</span>
              </ykc-detail-item>
              <ykc-detail-item :label="'结算时间：'">
                <span>{{ dealData(detailData.tradeTime) }}</span>
              </ykc-detail-item>
            </ykc-form>
          </div>
        </ykc-detail>
      </div>
      <!-- 用户支付信息/订单 end -->
      <!-- 充电明细 start -->
      <ykc-detail
        :tips="tips"
        :isLine="true"
        :titles="['充电明细']"
        class="table-body"
        ref="headLeft_three">
        <div slot="cvBody">
          <ykc-table :data="chargedDetail" :columns="tableColumns" v-if="chargedDetail.length != 0">
            <div slot="pagination" v-if="chargedDetail.length != 0">
              <ykc-pagination
                align="right"
                :total="pageInfo.total"
                :page-size.sync="pageInfo.size"
                :current-page.sync="pageInfo.current"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"></ykc-pagination>
            </div>
          </ykc-table>
        </div>
      </ykc-detail>

      <!-- 充电明细 end -->

      <!-- 充电流程 start -->
      <ykc-detail
        :tips="tips"
        :isLine="true"
        :titles="['充电流程']"
        class="table-body"
        ref="headLeft_four">
        <div slot="cvBody">
          <div class="step-container">
            <div class="steps-line"></div>
            <div class="card-wrap">
              <div class="steps-card">
                <div class="card-item">订单提交</div>
              </div>
              <div class="card-time">{{ dealData(detailData.submitTime) }}</div>
            </div>
            <div class="steps-line"></div>
            <div class="card-wrap">
              <div class="steps-card">
                <div class="card-item">开始充电</div>
              </div>
              <div class="card-time">{{ dealData(detailData.startTime) }}</div>
            </div>
            <div class="steps-line"></div>
            <div class="card-wrap">
              <div class="steps-card">
                <div class="card-item">结束充电</div>
              </div>
              <div class="card-time">{{ dealData(detailData.endTime) }}</div>
            </div>
            <div class="steps-line"></div>
            <div class="card-wrap">
              <div class="steps-card">
                <div class="card-item">订单支付</div>
              </div>
              <div class="card-time">{{ dealData(detailData.tradeTime) }}</div>
            </div>
          </div>
        </div>
      </ykc-detail>
      <!-- 充电流程 end -->
    </div>
  </scroll-layout>
</template>

<script>
  import { localGetItem, code } from '@/utils';
  import { orderPage } from '@/service/apis';

  export default {
    name: 'anxinOrderDetail',
    components: {},
    data() {
      return {
        tips: '',
        detailData: {},
        chargedDetail: [],
        tableColumns: [
          {
            label: '序号',
            type: 'index',
            minWidth: '50',
            align: 'center',
          },
          {
            label: '时间',
            prop: 'createTime',
            minWidth: '180',
          },
          {
            label: '电流(A)',
            prop: 'current',
            minWidth: '100',
          },
          {
            label: '电压(V)',
            prop: 'voltage',
            minWidth: '100',
          },
          {
            label: '功率(kW)',
            prop: 'power',
            minWidth: '100',
          },
          {
            label: '电量(kWh)',
            prop: 'degree',
            minWidth: '100',
          },
        ],
        pageInfo: {
          current: 1,
          size: 10,
          total: 0,
        },
        pageButtons: [
          {
            text: '返回',
            type: 'primary',
            enabled: true,
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
      };
    },
    created() {
      this.getDetail();
    },
    methods: {
      /**
       * 获取详情数据
       */
      getDetail() {
        const { recordId, gunCode } = this.$route.query;
        orderPage
          .anxinChargingOrderInfo({ recordId, gunCode })
          .then(res => {
            this.detailData = res;
            this.tips = res.exceptionMsg ? [{ type: 'error', text: res.exceptionMsg }] : [];
          })
          .catch(err => {
            console.log(err);
          });
      },
      dealData(data) {
        return data || '--';
      },
      /**
       * 分页器页数
       * */
      handleCurrentChange(val) {
        this.pageInfo.current = val;
        // TODO: 如果需要分页获取充电明细数据，请在这里实现
      },
      /**
       * 分页器条数
       * */
      handleSizeChange(val) {
        this.pageInfo.current = 1;
        this.pageInfo.size = val;
        // TODO: 如果需要分页获取充电明细数据，请在这里实现
      },
    },
  };
</script>

<style lang="scss" scoped>
  .real-time-detail {
    .flexConent {
      display: flex;
      justify-content: space-between;

      .left {
        width: 49%;
      }
    }

    .step-container {
      display: flex;
      justify-content: space-around;
      position: relative;

      .steps-line {
        position: absolute;
        top: 20px;
        left: 10%;
        width: 80%;
        height: 1px;
        background-color: #e0e0e0;
        z-index: 1;
      }

      .card-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 2;

        .steps-card {
          width: 80px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #f5f7fa;
          border-radius: 4px;
          margin-bottom: 10px;
          position: relative;

          .card-item {
            font-size: 14px;
            color: #606266;
          }

          &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #409eff;
          }
        }

        .card-time {
          font-size: 12px;
          color: #909399;
        }
      }
    }

    .table-body {
      margin-top: 20px;
    }

    .bottom-content {
      display: flex;
      justify-content: space-between;

      .list-left {
        width: 50%;
      }

      .list-right {
        width: 50%;
      }
    }
  }
</style>
